import { useState } from "react";
import './SolutionComponent.scss';
import Solution1 from '../assets/images/solution 1.jpg';
import Solution2 from '../assets/images/solution 2.jpg';
import SubmitDesign from "./SubmitDesign";

const Sloutions: React.FC = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState<"design" | "catalog" | "needs">("design");

  const openModal = (type: "design" | "catalog" | "needs") => {
    setModalType(type);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
    return(
        <div className="solutions">
            <h2>2 Easy Solutions</h2>
            <p className="subheading">
                To Boost Your Seamless Clothing Business <br />
            <span>Which scheme do you prefer? Kindly compare our SUPER MOQ with other factories!</span>
        </p>

        <div className="solutions__container">
        {/* Card 1 */}
        <div className="solutions__card">
          <div className="image-container">
            <img
              src={Solution1}
              alt="Customize new designs"
            />
          </div>
          <h3>#1, Customize new designs</h3>
          <p>
            Find you a Money-saving, Worry-free, but High-end customized
            seamless clothing manufacturing solution.
          </p>
          <button onClick={() => openModal("design")}>SUBMIT YOUR DESIGN</button>
        </div>
        {/* "OR" text */}
        <div className="solutions__or">" OR "</div>

        {/* Card 2 */}
        <div className="solutions__card">
          <div className="image-container">
            <img
              src={Solution2}
              alt="Your logo on our stock designs"
            />
          </div>
          <h3>#2, Your logo on our stock designs</h3>
          <p>
            We'll help you print your logo on our more than 100 existing
            designs. Small order acceptable, MOQ=1piece.
          </p>
          <button onClick={() => openModal("catalog")}>REQUEST FOR CATALOGS</button>
        </div>
        {isModalOpen && <SubmitDesign closeModal={closeModal} formType={modalType} />}
        </div>
      </div>
   );
};

export default Sloutions;